import React from 'react';
import { LoadingSpinner } from '../../common/LoadingSpinner';

interface SettingsCardProps {
  title: string;
  description: string;
  children: React.ReactNode;
  isLoading?: boolean;
}

export function SettingsCard({ title, description, children, isLoading }: SettingsCardProps) {
  return (
    <div className="bg-background-card rounded-xl border border-gray-800 overflow-hidden">
      <div className="p-6">
        <h2 className="text-lg font-semibold text-white mb-1">{title}</h2>
        <p className="text-sm text-gray-400 mb-6">{description}</p>
        
        {isLoading ? (
          <div className="flex justify-center py-4">
            <LoadingSpinner />
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
}